import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";

import { PREVIEW_NEEDED_LENGTH } from "../../constants";
import { parseLinks } from "../../../../../../utils/parseLinks";

interface IContentPreviewProps {
  content: string;
}

const ContentPreview: React.FC<IContentPreviewProps> = ({ content }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  content = content?.replaceAll('\n', "</br>");
  const isContentPreviewNeeded = content.length > PREVIEW_NEEDED_LENGTH;

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });

  const displayedContent = isExpanded ? content : `${content.slice(0, PREVIEW_NEEDED_LENGTH)}`;
  const contentWithLinks = parseLinks(displayedContent);
  const sanitizedContent = DOMPurify.sanitize(contentWithLinks);

  return (
    <p style={{ display: "inline-block", wordBreak: "break-word" }}>
      <span dangerouslySetInnerHTML={{ __html: sanitizedContent }}/>
      {isContentPreviewNeeded && !isExpanded && "..."}
      {isContentPreviewNeeded && (
        <span
          style={{
            marginLeft: 8,
            textDecoration: "underline",
            cursor: "pointer",
            color: "#555",
          }}
          onClick={toggleExpand}
        >
          {isExpanded ? t('home_page.see_less') : t('home_page.see_more')}
        </span>
      )}
    </p>
  );
};

export default ContentPreview;
